import React from 'react';

export default function ColumnTitlesMobile(props) {
  const yearTab = (index) => {
    const activeStyle =
      props.year === index
        ? {
            color: `${props.tenant.primary}`,
            borderBottom: `5px solid ${props.tenant.primary}`,
          }
        : {
            color: `${props.tenant.primary}`,
          };

    return (
      <h2 style={activeStyle}>
        <span
          onClick={() => {
            props.changeYear(index);
          }}
          onKeyDown={(e) => {
            if (['Enter'].includes(e.key)) props.changeYear(index);
          }}
          role="button"
          tabIndex="0"
        >
          {`Year ${index + 1}`}
        </span>
      </h2>
    );
  };

  const getColumnTitle = () => {
    return (
      <div className="year-title-container mobile">
        <div className="year-tabs-container">
          {yearTab(0)}
          {yearTab(1)}
          {yearTab(2)}
          {yearTab(3)}
        </div>
        <div className="current-year">
          <p className="year-mobile">{`Year ${props.year + 1}`}</p>
        </div>
      </div>
    );
  };

  return <div className="column-titles">{getColumnTitle()}</div>;
}
